import React, { Component } from 'react';
import * as Highcharts from 'highcharts';
import { Button } from "@material-ui/core";
import show_icon from "../../assets/Icons/show.png";
import hide_icon from "../../assets/Icons/hide.png";

import Tooltip, { TooltipContent } from "../../components/Tooltip/tooltip";

// hides/shows all series on the chart
export default class ToggleChartSeries extends Component {
    state = {
        hidden: false
    }

    componentDidMount() {
        this._setup();
    }
    render() {
        return (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <Tooltip delay={50}>
                    <div>
                    <Button onClick={() => this._buttonClick()}>
                        <div style={{width:50,color:'#4E5BE6',fontWeight:500}}>{this.state.hidden ? 'Show' : 'Hide'}</div>
                        {this.state.hidden ? <img src={hide_icon} alt="hide" style={{height: 22, width: 22}} /> : <img src={show_icon} alt="show" style={{height: 22, width: 22}} />}
                    </Button>
                    </div>
                    <TooltipContent>
                        <div style={{fontSize:12}}>
                            {this.state.hidden ? 'Show all chart elements' : 'Hide all chart elements'}
                        </div>
                    </TooltipContent>
                </Tooltip>
            </div>
        )
    }

    _setup() {
        if (this.props.chart == null) return;
        if (this.props.chart.current == null) return;

        const chart = this.props.chart.current.getChart();

        this._setupChart(chart);
    }
    _buttonClick() {
        if (this.props.chart == null) return;
        if (this.props.chart.current == null) return;

        const chart = this.props.chart.current.getChart();
        chart.series.forEach(x => x.setVisible(this.state.hidden, false));
        chart.redraw();
        this._handleHideShowEvent();
    }
    _setupChart(chart) {
        Highcharts.removeEvent(chart, 'addSeries');
        Highcharts.addEvent(chart, 'addSeries', (event) => {
            event.options.events = {
                hide: () => this._handleHideShowEvent(),
                show: () => this._handleHideShowEvent()
            }
        });
    }
    _handleHideShowEvent() {
        const chart = this.props.chart.current.getChart();
        const areAllHidden = chart.series.every(x => !x.visible);
        this.setState({ hidden: areAllHidden });
    }
}


// WEBPACK FOOTER //
// ./src/components/ToggleChartSeries/ToggleChartSeries.js